import { isGlobalFeatureEnabled } from "owa-feature-flags";

/**
 * Whether to send CalendarSurface as a BizChat message annotation app context when the user
 * is on the calendar grid (surface). Gated by a dedicated flight so it can roll out
 * independently of the calendar event drafting app context.
 */
export function isCalendarSurfaceMessageAnnotationEnabled(): boolean {
    return isGlobalFeatureEnabled("cal-copilot-calendar-surface-message-annotation");
}
